var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-page",class:{ loaded: _vm.loaded },style:({ height: `${_vm.height}px`, width: `${_vm.width}px` }),attrs:{"id":`page-${_vm.proxyPage.pageNumber}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }